import DxCompanyData from "./DxCompanyData";
import completeCompany from "./DxCompanyTestValues";

export class DxCompanyBase {
    constructor ( dataStore ) {
        this.dataStore = dataStore
    }

    // Returns a promise
    create(company) {
        DxCompanyData.validate(company)
        return this.dataStore.create(company)
    }

    // Returns a promise
    retrieve() {
        return this.dataStore.retrieve()
    }

    // Returns a promise
    retrieveAcceptableNaics() {
        return this.dataStore.retrieveAcceptableNaics()
    }

    // Returns a promise
    retrieveNaicsCodes(searchTerm) {
        return this.dataStore.retrieveNaicsCodes(searchTerm)
    }

    // Returns a promise
    retrieveTest() {
        return new Promise((resolve, reject) => {
            resolve(completeCompany)
        })
    }

    // Returns a promise
    store(company) {
        DxCompanyData.validate(company)
        return this.dataStore.store(company)
    }

    // Returns a promise
    retrieveUploadURL(fileName){
        return this.dataStore.retrieveUploadURL(fileName)
    }

    // Returns a promise
    listUpload(){
        return this.dataStore.listUpload()
    }

}

export default DxCompanyBase